<template>
  <div class="address-list">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" :to="to" />
    <listbox
      :list="addressList"
      :list-map="listMap"
      :action="{ name: 'edit' }"
      @item-action="itemAction"
      :height="listboxHeight"
    />
    <form-button-buttom text="新增地址" type="primary" size="small" @click="pushAddress({})" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
const componentName = 'AddressList'
export default {
  name: componentName,
  mixins: [Body],
  data() {
    return {
      title: '我的地址',
      listboxHeight: (h) => h - 100
    }
  },
  computed: {
    ...mapGetters('payment/address', [
      'addressList'
    ]),
    orderId() { return this.$route.query.orderId },
    addressId() { return this.$route.query.addressId },
    to() {
      const orderId = this.orderId // 订单ID
      const name = orderId == null ? 'addressList' : 'confirmOrder'
      return {
        name, params: { id: orderId }
      }
    }
  },
  // created() {
  //   this.getList()
  // },
  activated() {
    this.getList()
  },
  methods: {
    getList() {
      this.$store.dispatch('payment/address/getList')
    },
    listMap(item) {
      const name = `${item.contactName} ${item.contactNo}` // 姓名手机号
      const nametags = item.defaultMark && [{ text: '默认' }] || [] // 标签
      const subname = item.mergeAreaDetail // 地址
      return { name, nametags, subname }
    },
    // 列表事件
    itemAction({ item, action }) {
      // 编辑地址
      if (action.name === 'edit') {
        this.pushAddress({ item })
      }
      // 选择地址（需要设置为默认）
      if (action.name === 'item') {
        const id = this.orderId
        if (!id) return
        // 选择地址，返回订单页面
        this.$store.dispatch('payment/address/getItem', { id: item.id })
        // 返回订单页面
        this.$router.back()
        // this.$router.replace({
        //   name: 'confirmOrder',
        //   params: { id }
        // })
      }
    },
    // 添加或修改地址
    pushAddress({ item }) {
      const orderId = this.orderId
      this.$log.debug('pushAddress', item)
      this.$router.push({
        name: 'addressPush', query: {
          orderId,
          addressId: item ? item.id : 0
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-list {
  margin-bottom: 100px;
  // 底部按钮
  .form-bottom-button.form-bottom-label {
    background-color: #F7F9FB;
    border-top: 1px solid #EEEEEE;
  }
  .listbox {
    ::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
